module.exports = __webpack_public_path__ + "img/weixin.fbc7f94c.png";